import { observer } from 'mobx-react';
import { makeStyles, Theme } from '@material-ui/core/styles';
import { Grid, Typography } from '@material-ui/core';
import { createCurrencyField, CurrencyField } from '@roc/ui';
import clsx from 'clsx';
import { useStore } from '@roc/client-portal-shared/hooks';
import { useUserStore } from '@roc/feature-app-core';

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    width: '100%',
  },
}));

export const FinancialInformationStep = observer(() => {
  const classes = useStyles();
  const { identityCheckStore } = useStore();
  const { financialInformationForm } = identityCheckStore;
  const { userStore } = useUserStore();
  const { isNportalUser } = userStore;

  const assets = financialInformationForm.form.fields.assets.value || 0;
  const liabilities =
    financialInformationForm.form.fields.liabilities.value || 0;
  const netWorth = assets - liabilities;

  return (
    <Grid container spacing={2} className={clsx(classes.container)}>
      <Grid item xs={12}>
        <Typography variant="h5">Net Worth</Typography>
      </Grid>
      <Grid item xs={12} sm={4}>
        {createCurrencyField({
          label: 'Assets',
          fieldName: 'assets',
          testId: 'assets',
          store: financialInformationForm,
          disabled: !isNportalUser && identityCheckStore.financialInformationStatus === 'Accepted'
        })}
      </Grid>
      <Grid item xs={12} sm={4}>
        {createCurrencyField({
          label: 'Liabilities',
          fieldName: 'liabilities',
          testId: 'liabilities',
          store: financialInformationForm,
          disabled: !isNportalUser && identityCheckStore.financialInformationStatus === 'Accepted'
        })}
      </Grid>
      <Grid item xs={12} sm={4}>
        <CurrencyField
          testId={'netWorth'}
          disabled={true}
          variant={'outlined'}
          standaloneLabel={true}
          label={'Total Net Worth'}
          value={netWorth}
          onChange={() => null}
          fullWidth
        />
      </Grid>
    </Grid>
  );
});
